import { computed } from '@ember/object';
import { readOnly } from '@ember/object/computed';
import { ProtoBaseModel, attr, repeated } from '@square/dashboard-data/utils/ember-model-stubs';
import Enum from '@square/dashboard-utilities/utils/enum';
import AudienceParams from '@square/dashboard-data/models/squareup/rolodex/audience-params';
import Filter from '@square/dashboard-data/models/squareup/rolodex/filter';
export const AudienceType = new Enum('CARDS_ON_FILE', 'CASUAL', 'CHURN_RISK', 'LOYAL', 'TWO_VISITS_SIX_MONTHS', 'SOCIAL', 'NO_GROUP_ASSIGNED', 'ONLINE_STORE_AUDIENCE', 'RECENT_FEEDBACK_POSITIVE', 'RECENT_FEEDBACK_NEGATIVE', 'RECENT_FEEDBACK_ANY', 'LOYALTY_ALL', 'LOYALTY_CLOSE_TO_REWARD', 'GROUP_V2_SMART');
export const Code = new Enum(['SUCCESS', 'DUPLICATE']);
export const EDITABLE_AUDIENCE_TYPES = [AudienceType.CASUAL, AudienceType.CHURN_RISK, AudienceType.LOYAL];
export const GroupType = new Enum('MANUAL_GROUP', 'AUDIENCE_GROUP', 'INTERNAL_GROUP');
export const GroupOptions = ProtoBaseModel.extend({
  includeCounts: attr(Boolean),
  shouldSetAudienceParams: attr(Boolean)
});
const Group = ProtoBaseModel.extend({
  merchantToken: attr(String),
  groupToken: attr(String),
  groupType: attr(GroupType),
  audienceType: attr(String),
  audienceParams: attr(AudienceParams),
  name: attr(String),
  needsRefresh: attr(Boolean),
  externalImportInProgress: attr(Boolean),
  numCustomers: attr(Number, {
    default: 0
  }),
  numEmailable: attr(Number, {
    default: 0
  }),
  numManual: attr(Number, {
    default: 0
  }),
  filters: repeated(Filter),
  hidden: attr(Boolean),
  // copied from directory/group.js
  count: readOnly('numCustomers'),
  isDirty: computed('_dirtyAttributes.[]', 'audienceParams.isDirty', function (...args) {
    return this._super(...args) || this.audienceParams?.isDirty;
  })
});

// Request / Response
export const GroupError = ProtoBaseModel.extend({
  code: attr(Code),
  debugText: attr(String)
});
export const CreateGroupRequest = ProtoBaseModel.extend({
  merchantToken: attr(String),
  group: attr(Group)
});
export const CreateGroupResponse = ProtoBaseModel.extend({
  group: attr(Group),
  error: attr(GroupError)
});
export const DeleteGroupRequest = ProtoBaseModel.extend({
  merchantToken: attr(String),
  groupToken: attr(String),
  deleteContacts: attr(Boolean)
});

// Definition: https://prototype.sqprod.co/#/docs/squareup.rolodex.DeleteGroupResponse.Error
export const DeleteGroupResponseErrorCode = new Enum(['BULK_DELETE_SIZE_LIMIT_EXCEEDED']);
export const DeleteGroupResponseError = ProtoBaseModel.extend({
  code: attr(DeleteGroupResponseErrorCode)
});
export const DeleteGroupResponse = ProtoBaseModel.extend({
  success: attr(Boolean),
  error: attr(DeleteGroupResponseError)
});
export const GetGroupRequest = ProtoBaseModel.extend({
  merchantToken: repeated(String),
  groupToken: attr(String),
  groupOptions: attr(GroupOptions)
});
export const GetGroupResponse = ProtoBaseModel.extend({
  group: attr(Group)
});
export const ListGroupsRequest = ProtoBaseModel.extend({
  merchantToken: repeated(String),
  automaticAvailable: attr(Boolean),
  groupOptions: attr(GroupOptions)
});
export const ListGroupsResponse = ProtoBaseModel.extend({
  group: repeated(Group),
  groupOptions: attr(GroupOptions)
});
export const UpdateGroupRequest = ProtoBaseModel.extend({
  merchantToken: attr(String),
  group: attr(Group),
  groupOptions: attr(GroupOptions)
});
export const UpdateGroupResponse = ProtoBaseModel.extend({
  group: attr(Group),
  error: attr(GroupError)
});
export default Group;